import React from 'react';
import BadgeItem from '../../../Components/Ui/BadgeItem';

const BadgeConfig = {
  전체: { bg: 'bg-primary/10', text: 'text-primary' },
  사업장: { bg: 'bg-blue-50', text: 'text-blue-600' },
  부서: { bg: 'bg-blue-50', text: 'text-blue-600' },
  회사: { bg: 'bg-primary/10', text: 'text-primary' },
  중요: { bg: 'bg-red-50', text: 'text-red-600' },
  NEW: { bg: 'bg-orange-500', text: 'text-white' },
  default: { bg: 'bg-slate-100', text: 'text-slate-600' },
  승인대기: { bg: 'bg-orange-100', text: 'text-orange-500' },
  승인요청: { bg: 'bg-orange-100', text: 'text-orange-500' },
  서명요청: { bg: 'bg-indigo-50', text: 'text-indigo-600' },
  결재완료: { bg: 'bg-emerald-50', text: 'text-emerald-700' },
  결재요청: { bg: 'bg-amber-50', text: 'text-amber-700' },
  결재대기: { bg: 'bg-slate-100', text: 'text-slate-600' },
  반려: { bg: 'bg-red-50', text: 'text-red-600' },
  대기: { bg: 'bg-slate-100', text: 'text-slate-600' },
  작업허가서: { bg: 'bg-blue-50', text: 'text-blue-600' },
  작업재개: { bg: 'bg-red-50', text: 'text-red-500' },
  교육일지: { bg: 'bg-emerald-50', text: 'text-emerald-700' },
  보호구: { bg: 'bg-teal-50', text: 'text-teal-700' },
  안전보건위원회: { bg: 'bg-violet-50', text: 'text-violet-700' },
  '도급사업 협의체 회의': { bg: 'bg-sky-50', text: 'text-sky-700' },
  도급사업협의체회의: { bg: 'bg-sky-50', text: 'text-sky-700' },
  작성완료: { bg: 'bg-emerald-50', text: 'text-emerald-700' },
};

const pickField = (row, ...keys) => {
  if (!row) return '';
  for (const key of keys) {
    const v = row[key];
    if (v != null && String(v).trim() !== '') return String(v).trim();
  }
  return '';
};

/** 공지 상세 — 목록과 동일: 중요 + 구분(전체/사업장/부서)만 */
function NoticeDetailBadges({ data }) {
  if (!data) return null;

  const gubun = pickField(data, 'gubun', 'Gubun') || '0';
  const gubunNm = pickField(data, 'gubunNm', 'GubunNm');
  const noticeYn = pickField(data, 'noticeYn', 'NoticeYn').toUpperCase();

  const scopeLabel =
    gubunNm ||
    (gubun === '0'
      ? '전체'
      : gubun === '1'
        ? '사업장'
        : gubun === '2'
          ? '부서'
          : gubun === '3'
            ? '회사'
            : '');

  return (
    <div className="flex flex-wrap gap-2">
      {noticeYn === 'Y' && <BadgeItem type="중요" label="중요" />}
      {scopeLabel ? (
        <BadgeItem type={scopeLabel} label={scopeLabel} />
      ) : null}
    </div>
  );
}

/** 단일 뱃지 (결재대기 등) 또는 공지 상세(data) */
export default function Badge({ data, type, label, className = '' }) {
  if (data) {
    return <NoticeDetailBadges data={data} />;
  }

  const config = BadgeConfig[type] || BadgeConfig.default;

  return (
    <div
      className={`inline-flex h-4.5 items-center justify-center rounded-xl px-2 py-1.5 text-[10px] font-bold whitespace-nowrap ${config.bg} ${config.text} ${className}`}
    >
      {label}
    </div>
  );
}
